import { render } from "./CompletedTrainingView.vue?vue&type=template&id=73e238f3&scoped=true"
import script from "./CompletedTrainingView.vue?vue&type=script&lang=js"
export * from "./CompletedTrainingView.vue?vue&type=script&lang=js"

import "./CompletedTrainingView.vue?vue&type=style&index=0&id=73e238f3&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e238f3"]])

export default __exports__